<div class="container">
  <div class="row justify-content-center align-items-center min-vh-100">
    <div class="col-12 col-sm-8 col-md-6 col-lg-4">
      <mat-card class="text-center">
        <mat-card-header>
          <mat-card-title>
            <div class="text-center w-100">
              <mat-icon class="page-icon text-danger">lock_person</mat-icon>
              <h2>Acceso Denegado</h2>
              <p class="text-muted fst-italic">Privilegios Insuficientes</p>
            </div>
          </mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <div class="alert alert-danger">
            Tu cuenta actual no cuenta con los <strong>permisos técnicos</strong> necesarios
            para acceder a este recurso.
          </div>
        </mat-card-content>

        <mat-card-actions class="px-3 pb-3">
          <button mat-flat-button color="primary" class="w-100 mb-2" routerLink="/login">
            <mat-icon>home</mat-icon>
            Volver al Inicio Seguro
          </button>
          <button mat-stroked-button class="w-100" (click)="goBack()">
            Solicitar acceso al administrador
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</div>
